import { FC } from 'react';
import classnames from 'classnames';
import { graphql, useFragment } from 'react-relay';

import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';
import { Spinner } from 'dibs-elements/exports/Spinner';
import PenIcon from 'dibs-icons/exports/legacy/Pen';
import KeyIcon from 'dibs-icons/exports/legacy/EarlyAccess';
import { useDibsSetApprovalForAll } from 'dibs-crypto-utils/exports/useDibsSetApprovalForAll';

import { NftProfileImportCollectionViewToolbar_contractImport$key as contractImport$key } from './__generated__/NftProfileImportCollectionViewToolbar_contractImport.graphql';
import { NftProfileImportCollectionViewToolbar_viewer$key as viewer$key } from './__generated__/NftProfileImportCollectionViewToolbar_viewer.graphql';

import styles from './styles/NftProfileImportCollectionViewToolbar.scss';

export const NftProfileImportCollectionViewToolbar: FC<{
    viewer?: viewer$key | null;
    contractImport?: contractImport$key | null;
    onEditClick: () => void;
}> = ({ contractImport: contractImportRef = null, viewer: viewerRef = null, onEditClick }) => {
    const contractImport = useFragment(
        graphql`
            fragment NftProfileImportCollectionViewToolbar_contractImport on NftTokenContractImport {
                contractAddress {
                    address
                }
                contract {
                    tokenStandard
                }
            }
        `,
        contractImportRef
    );
    const viewer = useFragment(
        graphql`
            fragment NftProfileImportCollectionViewToolbar_viewer on Viewer {
                ...useDibsSetApprovalForAll_viewer
            }
        `,
        viewerRef
    );
    const isERC1155 =
        contractImport?.contract?.tokenStandard === 'NFT_TOKEN_CONTRACT_TOKEN_STANDARD_ERC1155';
    const [setApprovalForAll, isApprovedForAll, approvalInFlight] = useDibsSetApprovalForAll(
        contractImport?.contractAddress?.address,
        viewer,
        isERC1155
    );

    return (
        <>
            <Link
                onClick={onEditClick}
                buyerLinkType="linkNoDecoration"
                className={classnames(styles.linkButton, styles.divider)}
            >
                <PenIcon className={styles.icon} />
                <FormattedMessage
                    id="nft.publicProfile.editCollectionCta"
                    defaultMessage="Edit Collection"
                />
            </Link>
            {isApprovedForAll === false && !isERC1155 && (
                <Link
                    onClick={() => setApprovalForAll(true)}
                    buyerLinkType="linkNoDecoration"
                    className={classnames(styles.linkButton, styles.divider)}
                >
                    {approvalInFlight ? (
                        <Spinner containerClass={styles.icon} black />
                    ) : (
                        <KeyIcon className={styles.icon} />
                    )}
                    <FormattedMessage
                        id="nft.publicProfile.approveDibsCta"
                        defaultMessage="Approve 1stDibs"
                    />
                </Link>
            )}
            {isApprovedForAll && (
                <span className={classnames(styles.linkButton, styles.divider)}>
                    <FormattedMessage
                        id="nft.publicProfile.approvedDibs"
                        defaultMessage="1stDibs is approved"
                    />
                </span>
            )}
        </>
    );
};
